module.exports = __webpack_public_path__ + "img/one.b45b7564.png";